import { FC } from 'react'
import {
  BooleanInput, Edit, SelectInput, SimpleForm,
  TextInput, required, useRecordContext, useGetOne,
} from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { BackToOrgActions, EnvironmentDisplay, LOG_LEVEL_CHOICES, OrgLinkEditToolbar } from '../../components'
import Auth0UserAutocomplete from '../../components/Auth0UserAutocomplete'
import { OrganizationProxyLinkOut, OrganizationOut } from '../../types/apiRequests'

const Auth0UserField: FC = () => {
  const record = useRecordContext<OrganizationProxyLinkOut>()
  const { setValue } = useFormContext()

  const { data: organization } = useGetOne<OrganizationOut>(
    'organization',
    { id: record?.organization_id ?? '' },
    { enabled: !!record?.organization_id }
  )

  return (
    <Auth0UserAutocomplete
      auth0OrgId={organization?.idp_org_id}
      freeSolo
      initialValue={record?.identity_email ?? ''}
      onSelect={(user) => setValue('identity_email', user?.email ?? '', { shouldDirty: true })}
      onInputChange={(value) => setValue('identity_email', value, { shouldDirty: true })}
    />
  )
}

const ProxyEnvironmentDisplay: FC = () => {
  const record = useRecordContext<OrganizationProxyLinkOut>()
  if (!record?.environment_display_name) return null
  return <EnvironmentDisplay name={record.environment_display_name} />
}

const OrganizationProxyLinkEdit: FC = () => (
  <Edit
    mutationMode="pessimistic"
    redirect={false}
    actions={<BackToOrgActions tabPath="proxy-links" />}
  >
    <SimpleForm toolbar={
      <OrgLinkEditToolbar confirmContentKey="delete.confirmContentProxyLink" tabPath="proxy-links" />
    }>
      <ProxyEnvironmentDisplay />
      <Auth0UserField />
      <TextInput source="target_url" label="data.targetUrl" fullWidth validate={required()} />
      <BooleanInput source="enabled" label="data.enabled" />
      <SelectInput
        source="log_level"
        label="data.logLevel"
        choices={LOG_LEVEL_CHOICES}
      />
    </SimpleForm>
  </Edit>
)

export default OrganizationProxyLinkEdit
